import React from "react";
import { Award, Users, Zap, Shield } from "lucide-react";

const ITEMS = [
  { icon: Award, label: "Broadcast-grade graphics" },
  { icon: Users, label: "Built for local & club cricket" },
  { icon: Zap, label: "<200ms live sync" },
  { icon: Shield, label: "Money-back on your first match" },
];

export default function SocialProofStrip() {
  return (
    <section className="py-6 border-y border-slate-800 bg-slate-900/50">
      <div className="max-w-6xl mx-auto px-6 flex flex-wrap items-center justify-around gap-6 text-slate-400 text-sm">
        {ITEMS.map(({ icon: I, label }) => (
          <div key={label} className="flex items-center gap-2">
            <I size={16} className="text-blue-400" />
            <span>{label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
